import { APPROVALS_START_REVIEW_EXPERIENCE } from '@confluence/experience-tracker/entry-points/ExperienceName.ts';

import {
	type ApprovalsWriteExperience,
	useApprovalsWriteExperience,
} from './useApprovalsWriteExperience.ts';

/**
 * Tracks `approvals/start-review` — the user asked for a review and it was created.
 * Covers both startApproval and startApprovalCombined.
 */
export const useStartReviewExperience = (): ApprovalsWriteExperience =>
	useApprovalsWriteExperience(APPROVALS_START_REVIEW_EXPERIENCE);
